import { ApplicationView } from "@mixitone/mvc";
import { PillTab } from "./PillTab";
import { Tab } from "./types";

interface Props {
  tabs: Tab[];
}

const PillTabs = ({ tabs }: Props) => {
  return (
    <div className="flex justify-center items-center pt-5" style={{ viewTransitionName: "pill-tabs" }}>
      <div className="bg-gray-100 p-1 rounded-full flex">
        {tabs.map((tab, index) => (
          <PillTab key={`pill-tab-${index}`} tab={tab} />
        ))}
      </div>
    </div>
  );
};

const PillTabsView = ApplicationView(PillTabs);
export { PillTabsView as PillTabs };
